import React from 'react'
import {useIntl} from 'react-intl'
import styled from '@emotion/styled'
import {FacilityIcon} from 'components/Accommodation/Facilities/FacilityIcon'
import {filterMessages} from 'components/Filters/filterMessages'
import {FacetType} from 'types/Search'
import {
  getFacetsSortedAlphabetically,
  MAX_MOBILE_POPULAR_FACILITIES
} from 'utils/facilities'
import {isFacetSelected} from 'utils/filters'

import {Accordion} from '@vio/atlas/Accordion'
import {cssTheme} from '@vio/atlas/themes'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {FacetCard} from '../FacetCard'
import {FacetFilterProps} from '../FacetFilter'
import {FacetFilterList} from '../FacetFilterList/FacetFilterList'

const FacetCardWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  gap: ${cssTheme.layout.spacing.s300};
  margin-bottom: ${cssTheme.layout.spacing.s600};
`

interface FacetsRenderCardProps extends FacetFilterProps {
  popularFacets: FacetType[]
  validFacets: FacetType[]
}
export const FacetsRenderCard: React.FC<FacetsRenderCardProps> = ({
  popularFacets,
  validFacets,
  searchParamName,
  getLabel,
  onChange,
  columns,
  filters,
  contractedMessage,
  hasAppliedFilters
}) => {
  const {formatMessage} = useIntl()
  const [showMore, setShowMore] = React.useState(false)

  const facetsCard = popularFacets.slice(0, MAX_MOBILE_POPULAR_FACILITIES)

  return (
    <div>
      <FacetCardWrapper>
        {facetsCard.map(facet => (
          <FacetCard
            key={facet.id}
            icon={
              <FacilityIcon
                facility={{id: +facet.id, objectID: facet.id}}
                size="lg"
              />
            }
            label={getLabel(facet.id) as string}
            isSelected={isFacetSelected(filters, facet.id)}
            onSelectCard={() => onChange(searchParamName, facet.id)}
          />
        ))}
      </FacetCardWrapper>

      <Accordion
        isBottomAligned
        size="sm"
        header={
          showMore ? (
            <FormattedMessageWrapper id="showLess" defaultMessage="Show less" />
          ) : (
            <FormattedMessageWrapper id="showMore" defaultMessage="Show more" />
          )
        }
        onToggle={setShowMore}
      >
        {showMore && (
          <FacetFilterList
            title={formatMessage(filterMessages.allTypes)}
            facets={getFacetsSortedAlphabetically(
              validFacets,
              getLabel as (T: string) => string
            )}
            filters={filters}
            searchParamName={searchParamName}
            getLabel={getLabel}
            columns={columns}
            contractedMessage={contractedMessage}
            onChange={onChange}
            hasAppliedFilters={hasAppliedFilters}
          />
        )}
      </Accordion>
    </div>
  )
}
